import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const MTN_API_BASE_URL = process.env.REACT_APP_MTN_API_BASE_URL || '';

const createApiClient = (baseURL = API_BASE_URL || undefined, config = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    ...(config.headers || {})
  };

  return axios.create({
    ...config,
    baseURL,
    headers
  });
};

const engineApi = createApiClient();
const mtnApi = createApiClient(MTN_API_BASE_URL);

export { engineApi, mtnApi };